import { Injectable } from '@angular/core';

import { environment } from '@environment/environment';

@Injectable({ providedIn: 'root' })
export class GoogleMapsLoaderService {
  private loadingPromise?: Promise<void>;

  load(): Promise<void> {
    if (this.loadingPromise) return this.loadingPromise;

    this.loadingPromise = new Promise((resolve, reject) => {
      (function (g: any) {
        let h: Promise<void> | undefined,
          a: HTMLScriptElement,
          k: string,
          p = 'The Google Maps JavaScript API',
          c = 'google',
          l = 'importLibrary',
          q = '__ib__',
          m = document,
          b = window as any;

        b = b[c] || (b[c] = {});
        const d = b.maps || (b.maps = {});
        const r = new Set<string>();
        const e = new URLSearchParams();

        const u = () =>
          h ||
          (h = new Promise<void>(async (f, n) => {
            a = m.createElement('script');
            e.set('libraries', [...r] + '');
            for (k in g)
              e.set(
                k.replace(/[A-Z]/g, (t) => '_' + t[0].toLowerCase()),
                g[k]
              );

            e.set('callback', c + '.maps.' + q);
            a.src = `https://maps.googleapis.com/maps/api/js?` + e;

            d[q] = () => {
              f();
            };

            a.onerror = () => {
              const err = Error(p + ' could not load.');
              reject(err);
              n(err);
            };
            const nonceScript = m.querySelector('script[nonce]') as HTMLScriptElement | null;
            a.nonce = nonceScript?.nonce || '';
            m.head.append(a);
          }));

        if (d[l]) {
          console.warn(p + ' only loads once. Ignoring:', g);
        } else {
          const stub = (f: string, ...n: any[]): Promise<unknown> =>
            r.add(f) &&
            u().then(() => {
              const real = (window as any).google?.maps?.importLibrary;
              if (!real || real === stub) throw Error(p + ' did not install importLibrary.');
              return real(f, ...n);
            });
          d[l] = stub;
        }
      })({
        v: 'weekly',
        key: environment.mapApiKey
      });

      (async () => {
        try {
          const core = await (window as any).google.maps.importLibrary('core');
          resolve();
        } catch (err) {
          reject(err);
        }
      })();
    });

    return this.loadingPromise;
  }
}
